import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'PickupSessionGroup';

const PickupSessionGroupApi: any = baseApi(endpoint);

export default PickupSessionGroupApi;